import React from 'react';
import ArrayMap from '../../../../lib/ArrayMap/ArrayMap';

interface IRescheduleInProgressProps {}

const RescheduleInProgress: React.FC<React.PropsWithChildren<React.PropsWithChildren<IRescheduleInProgressProps>>> = ({}) => {
  const content = [
    {
      title: `To Keep your current booking`,
      subTitle: `hit 'Cancel Request' below`,
    },
    {
      title: `To change the date or time you requested`,
      subTitle: `hit 'Cancel Request' below, and place a new reschedule request.`,
    },
  ];
  return (
    <div className="grid gap-5 px-4 mt-8">
      <p>A reschedule request is currently in progress.</p>

      <ArrayMap items={content}>
        {({ title, subTitle }) => (
          <p>
            <span className="font-medium">{title}</span>
            <br />
            <span className="text-gray-600 lg:text-gray-300">{subTitle}</span>
          </p>
        )}
      </ArrayMap>
    </div>
  );
};
export default RescheduleInProgress;
